import type { PreferredMemorizationMethod } from '@/features/students/types';

/**
 * Display copy for the Phase 8, Pilar A starter set (schema.prisma's
 * PreferredMemorizationMethod doc comment carries the same descriptions).
 * A deliberately minimal, revisable placeholder - not the full method
 * catalogue the product owner may eventually define.
 */
export const PREFERRED_METHOD_LABELS: Record<PreferredMemorizationMethod, string> = {
  TALAQQI_BERTAHAP: 'Talaqqi Bertahap',
  TARGET_HARIAN_MANDIRI: 'Target Harian Mandiri',
  MURAJAAH_INTENSIF: 'Murajaah Intensif',
};

export const PREFERRED_METHOD_DESCRIPTIONS: Record<PreferredMemorizationMethod, string> = {
  TALAQQI_BERTAHAP:
    'Hafalan baru sedikit demi sedikit, diulang bersama guru sebelum lanjut ke bagian berikutnya.',
  TARGET_HARIAN_MANDIRI:
    'Target harian ditentukan dan dikerjakan sendiri, diperiksa guru secara berkala.',
  MURAJAAH_INTENSIF:
    'Hafalan baru diperlambat, waktu lebih banyak dialokasikan untuk menjaga hafalan lama.',
};

export const PREFERRED_METHOD_OPTIONS: readonly PreferredMemorizationMethod[] = [
  'TALAQQI_BERTAHAP',
  'TARGET_HARIAN_MANDIRI',
  'MURAJAAH_INTENSIF',
];
